import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axiosInstance from "../../../../hooks/axiosInstance";
import { toast } from "react-toastify";

export default function CreatePermission({ show, closeModal, refreshPage }) {
  const [validationError, setValidationError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    permissions: [{ name: "", description: "" }],
  });

  const resetForm = () => {
    setFormData({
      permissions: [{ name: "", description: "" }],
    });
    setValidationError({});
  };

  const handleAddPermission = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      permissions: [...prevFormData.permissions, { name: "", description: "" }],
    }));
  };

  const handleRemovePermission = (idx) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      permissions: prevFormData.permissions.filter((_, index) => index !== idx),
    }));
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);
    try {
      await axiosInstance.post("/user/roles/create-permission", formData);
      handleClose();
      refreshPage();
      toast.success("Permission Created successfully!");
    } catch (error) {
      if (error.response && error.response.data.errors) {
        setValidationError(error.response.data.errors);
        toast.error("Failed to save.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="CreateUserMngt">
      <Modal show={show} onHide={handleClose} dialogClassName="modal-lg">
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Permission</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-end mb-3">
              <Button
                variant="danger"
                onClick={handleAddPermission}
                style={{ color: "#fff" }}
              >
                Add Permission
              </Button>
            </div>

            <h6>Permissions</h6>
            {formData.permissions.map((permission, idx) => (
              <div key={idx} className="row mb-3">
                <div className="col-md-6">
                  <Form.Group>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Permission Name
                        </span>
                      </div>
                      <Form.Control
                        type="text"
                        placeholder="Permission name"
                        value={permission.name}
                        onChange={(e) => {
                          const updatedPermissions = [...formData.permissions];
                          updatedPermissions[idx].name = e.target.value;
                          setFormData({
                            ...formData,
                            permissions: updatedPermissions,
                          });
                        }}
                        required
                      />
                    </div>

                    {validationError.permissions &&
                      validationError.permissions[idx]?.name && (
                        <small className="text-danger">
                          {validationError.permissions[idx].name[0]}
                        </small>
                      )}
                  </Form.Group>
                </div>

                <div className="col-md-5">
                  <Form.Group>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">Description </span>
                      </div>
                      <Form.Control
                        type="text"
                        placeholder="Description"
                        value={permission.description}
                        onChange={(e) => {
                          const updatedPermissions = [...formData.permissions];
                          updatedPermissions[idx].description = e.target.value;
                          setFormData({
                            ...formData,
                            permissions: updatedPermissions,
                          });
                        }}
                        required
                      />
                    </div>

                    {validationError.permissions &&
                      validationError.permissions[idx]?.description && (
                        <small className="text-danger">
                          {validationError.permissions[idx].description[0]}
                        </small>
                      )}
                  </Form.Group>
                </div>

                {formData.permissions.length > 1 && (
                  <div className="col-md-1 d-flex align-items-center">
                    <Button
                      variant="link"
                      onClick={() => handleRemovePermission(idx)}
                      style={{ fontSize: "20px", color: "red" }}
                    >
                      <i className="bi bi-x"></i>
                    </Button>
                  </div>
                )}
              </div>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              style={{
                backgroundColor: "#c4281b",
                color: "#fff",
                border: "none",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}
